module.exports = __webpack_public_path__ + "static/media/dots.1d1d853d.svg";